import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { serializeQueryParams } from 'src/app/service-helper';
import { environment } from 'src/environments/environment';
import {
  CategoryAnalysisReportGetFilter,
  PagedCategoryAnalysisReportGetResponse,
} from './models/category-analysis-report.service.model';
import { KeywordCloudResponse } from './models/keyword-cloud.service.model';

@Injectable({
  providedIn: 'root',
})
export class CategoryAnalysisReportService {
  constructor(private readonly http: HttpClient) {}

  private readonly baseURL: string = `${environment.apiUrl}/api/MentionedCategoriesReport`;

  get(
    filter: CategoryAnalysisReportGetFilter
  ): Observable<PagedCategoryAnalysisReportGetResponse> {
    const params = serializeQueryParams(filter);
    return this.http.get<PagedCategoryAnalysisReportGetResponse>(this.baseURL, {
      params,
    });
  }

  getKeywordCloud(
    filter: CategoryAnalysisReportGetFilter
  ): Observable<KeywordCloudResponse[]> {
    const params = serializeQueryParams(filter);
    return this.http.get<KeywordCloudResponse[]>(
      this.baseURL + '/CloudKeywords',
      { params }
    );
  }

  export(filters: CategoryAnalysisReportGetFilter) {
    return this.http.post(this.baseURL, filters, { responseType: 'blob' });
  }
}
